import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';
import RouterService from '@ember/routing/router-service';

// Copy of the @banking/ui go-to helper using the regular router service.
export default class GoTo extends Helper {
  @service router!: RouterService;

  compute([route]: [unknown], params: Record<string, string>) {
    if (typeof route !== 'string') {
      throw new TypeError('must pass a string route to this helper');
    }

    return () => {
      if (params) {
        this.router.transitionTo(route, { queryParams: params });
      } else {
        this.router.transitionTo(route);
      }
    };
  }
}
